module.exports = __webpack_public_path__ + "static/media/human-advantage-vest.c3e11e85.svg";